/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerPerCategoryResponse
 */
export interface FreelancerPerCategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof FreelancerPerCategoryResponse
     */
    category: string;
    /**
     * 
     * @type {number}
     * @memberof FreelancerPerCategoryResponse
     */
    freelancerCount: number;
}

/**
 * Check if a given object implements the FreelancerPerCategoryResponse interface.
 */
export function instanceOfFreelancerPerCategoryResponse(value: object): value is FreelancerPerCategoryResponse {
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('freelancerCount' in value) || value['freelancerCount'] === undefined) return false;
    return true;
}

export function FreelancerPerCategoryResponseFromJSON(json: any): FreelancerPerCategoryResponse {
    return FreelancerPerCategoryResponseFromJSONTyped(json, false);
}

export function FreelancerPerCategoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerPerCategoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'],
        'freelancerCount': json['freelancerCount'],
    };
}

export function FreelancerPerCategoryResponseToJSON(value?: FreelancerPerCategoryResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'category': value['category'],
        'freelancerCount': value['freelancerCount'],
    };
}

